<template>
    <div v-show="nickname" :class="['inviter', { isH5: isH5, vertical: isVertical }]">
        <img v-if="avatar" class="avatar" :src="avatar" :style="avatarStyles" />
        <span class="name" v-html="nickname"></span>
    </div>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
import { isH5 } from './utils.js';
import { LAYOUT } from '../constant/enum.js';

export default {
    props: {
        avatar: {
            type: String,
            default: ''
        },
        nickname: {
            type: String,
            default: ''
        },
        avatarSize: {
            type: Number,
            default: null
        },
        avatarMarginRight: {
            type: Number,
            default: null
        },
        layout: {
            type: String,
            default: LAYOUT.HORIZONTAL
        }
    },
    data() {
        return {
            isH5: isH5()
        };
    },
    computed: {
        isVertical() {
            return this.layout === LAYOUT.VERTICAL;
        },
        avatarStyles() {
            const styles = {};

            // 如果有传入 avatarSize，则覆盖默认的 width 和 height
            if (this.avatarSize !== null && this.avatarSize !== undefined) {
                styles.width = `${this.avatarSize}rem`;
                styles.height = `${this.avatarSize}rem`;
            }

            // 如果有传入 avatarMarginRight，则覆盖默认的间距（横向为 margin-right，竖向为 margin-bottom）
            if (this.avatarMarginRight !== null && this.avatarMarginRight !== undefined) {
                if (this.isVertical) {
                    styles.marginBottom = `${this.avatarMarginRight}rem`;
                } else {
                    styles.marginRight = `${this.avatarMarginRight}rem`;
                }
            }

            return styles;
        }
    }
};
</script>

<style lang="less" scoped>
.inviter {
    display: inline-flex;
    align-items: center;
    &.vertical {
        flex-direction: column;
        .avatar {
            margin-right: 0;
            margin-bottom: 0.1rem;
        }
    }
    &.isH5 {
        .avatar {
            margin-right: 0.14rem;
            width: 0.5rem;
            height: 0.5rem;
            border-radius: 50%;
            overflow: hidden;
            flex-shrink: 0;
        }
        .name {
            font-size: 0.32rem;
            line-height: 1;
            color: #000;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    &:not(.isH5) {
        .avatar {
            margin-right: 0.1rem;
            width: 0.4rem;
            height: 0.4rem;
            border-radius: 50%;
            overflow: hidden;
            flex-shrink: 0;
        }
        .name {
            font-size: 0.26rem;
            line-height: 1;
            color: #000;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
</style>
